import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
@Component({
  selector: 'app-ng-message',
  templateUrl: './ng-message.component.html',
  styleUrls: ['./ng-message.component.scss']
})
export class NgMessageComponent implements OnInit {
  constructor() {}
  @Input()
  public form: FormControl = new FormControl();

  ngOnInit(): void {}
}
